// Experiment keys for A/B Testing dealing with various types of redirects in/outside of web app

// redirect from / to /radio/home if true
export const REDIRECT_TO_HOME_ENABLED = 'web.redirectAllToHome.enabled';

// redirect to app store on play
export const PLAY_OPEN_IN_APP_ENABLED = 'web.play.openInApp.enabled';
